import React from 'react';

import { ErrorModalProps } from '../types';
import Modal from '@/lib/Modal';
import Icon from '@/lib/Icon/Icon';
import Button from '@/lib/Button';

const ErrorModal: React.FC<ErrorModalProps> = ({
  onDismiss,
  isOpen,
  title,
  description,
  ctaText,
  onCtaClick,
  children,
  hideCta = false,
  isCloseable = true,
}) => {
  return (
    <Modal showClose={isCloseable} className="[&&]:p-5" isOpen={isOpen} onDismiss={onDismiss}>
      <Modal.Body>
        <div className="d:w-1/2 d:flex d:flex-col d:items-center">
          <div
            data-testid="error-popup"
            className="mb-7 p-3 bg-surface-negative-faded inline-block rounded-md border border-negative-subtle"
          >
            <Icon width={24} fill="#D92D20" name="filledWarning" />
          </div>
          <h1 className="font-tasa font-semibold text-2xl text-on-grey-normal">{title}</h1>
          <p className="text-base text-on-grey-subtle mt-1 mb-8 d:text-center">{description}</p>
          {!hideCta ? <Button onClick={onCtaClick}>{ctaText}</Button> : null}
          {children}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ErrorModal;
